import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'framework/ui/mui-builder';
import useStakeholdersService from 'domain/projects/newProject/stakeholders/useStakeholdersService';
import useReconcileProjectNotifications, {
  PROJECT_NOTIFICATION_SCOPE,
} from '../../shared/notifications/useReconcileProjectNotifications';

type StakeholdersActionButtonProps = {
  isNotDefined: boolean;
  onConfirmed?: () => Promise<unknown>;
  projectId: string | number;
  stakeholdersUrl: string;
};

const StakeholdersActionButton = ({
  isNotDefined,
  onConfirmed,
  projectId,
  stakeholdersUrl,
}: StakeholdersActionButtonProps) => {
  const navigate = useNavigate();
  const { confirmStakeholders } = useStakeholdersService();
  const reconcileNotifications = useReconcileProjectNotifications();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isNotDefined) {
      navigate(stakeholdersUrl);
      return;
    }

    setIsLoading(true);
    try {
      await confirmStakeholders(String(projectId));
      await reconcileNotifications(String(projectId), [PROJECT_NOTIFICATION_SCOPE.STAKEHOLDERS]).catch(() => undefined);
      await onConfirmed?.();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button variant="contained" onClick={handleClick} loading={isLoading}>
      {isNotDefined ? 'Add stakeholders' : 'Confirm'}
    </Button>
  );
};

export default StakeholdersActionButton;
